<template>
  <transition name="fade">
    <div class="row justify-content-center">
      <div class="col-lg-10 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title bold">Well done, you may now provide your preferred loan amount</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 alert alert-success2">
                <p class="card-text text-justify pb-0 mb-0">Your maximum loanable amount is <strong>Php {{formLoan.max_loan | curr}}</strong></p>
                <em class="card-text text-justify pb-0 mb-0"><strong>Note:</strong> Requested loan amount is subject to assessment and approval by SB Corporation.</em>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Loan Amount</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                    </div>
                    <!-- <input-currency v-model="formLoan.req_loan_amt" class="form-control" :options="option_curr" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}" /> -->
                    <input type="number" v-model="formLoan.req_loan_amt" class="form-control" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}" />
                  </div>
                  <div>
                    <small class="text-grey float-right bold">{{convertedAmount}}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Loan Term (in months)</label>
                  <select class="form-control custom-select-sm" v-model="formLoan.req_loan_term" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_term.$error}" @change="changeLoanTerm">
                    <option :value='null' disabled>- Select -</option>
                    <option :value='12'>12</option>
                    <option :value='24'>24</option>
                    <option :value='36'>36</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- <div class="col-md-4">
                <div class="form-group">
                  <label>Grace Period (in months)</label>
                  <select class="form-control custom-select-sm" v-model="formLoan.grace_period" :class="{'is-invalid': $parent.submitting && $v.formLoan.grace_period.$error}">
                    <option :value='null' disabled>- Select -</option>
                    <option :value='0'>0</option>
                    <option :value='3'>3</option>
                    <option :value='6'>6</option>
                    <option v-if="formLoan.req_loan_term >= 24" :value='9'>9</option>
                    <option v-if="formLoan.req_loan_term >= 24" :value='12'>12</option>
                  </select>
                </div>
              </div> -->
              <div class="col-md-4">
                <div class="form-group">
                  <label>Service Fee</label>
                  <input type="text" class="form-control form-control-sm" :value="service_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Interest Rate</label>
                  <input type="text" class="form-control form-control-sm" :value="interest_rate + ' p.a.'" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>

            <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
            <button class="btn btn-primary float-right mr-1" @click="testMaxLoan">Test Computation</button>
          </div>
        </div>


      </div>
    </div>
  </transition>
</template>
<script>
  import moment from "moment";
  import {
    required,
    minLength,
    requiredIf
  } from "vuelidate/lib/validators";

  export default {
    props: ["formLoan"],
    data() {
      return {
        readonly: true,
        req_loan_amt: false,
        period: [],
        term: [12, 24, 36],
        total_ob: 0,


        option_curr: {
          currency: "USD",
          currencyDisplay: 'hidden',
          valueRange: {
            min: 0,
            max: 10000000
          }
        }
      };
    },
    validations: {
      formLoan: {
        req_loan_amt: {
          required,
        },
        req_loan_term: {
          required,
        },
        // grace_period: {
        //   required
        // },
      },
    },
    created() {
      // this.getLatestOB();
      this.evalLoan();
    },
    computed: {
      convertedAmount() {
        let val = this.formLoan.req_loan_amt;
        if (val > 0) {
          let num_parts = val.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      service_fee() {
        let x = '-';
        let g = this.formLoan.grace_period;
        let c = this.formLoan.category;

        let micro = ['N/A', '2.00%', '4.00%', '6.00%', '8.00%'];
        let sme = ['N/A', '1.50%', '3.00%', '4.50%', '6.00%'];
        let gp = [0, 3, 6, 9, 12];

        if (this.formLoan.service_fee) {
          x = this.formLoan.service_fee;
        } else {
          if (g) {
            switch (c) {
              case 1:
              case 2:
                x = micro[gp.indexOf(g)];
                break;
              case 3:
              case 4:
                x = sme[gp.indexOf(g)];
                break;
              default:
            }
          }
        }
        return x;
      },

      interest_rate() {
        let x = '-';
        let c = this.formLoan.category;
        if (this.formLoan.interest_rate_pa) {
          x = this.formLoan.interest_rate_pa;
        } else {
          switch (c) {
            case 1:
            case 2:
              x = '10%';
              break;
            case 3:
            case 4:
              x = '8%';
              break;
            default:
          }
        }
        return x;
      },
    },
    methods: {
      getLatestOB() {
        if (this.formLoan.existing_borrower) {
          this.$parent.payloading = true;
          axios.get('/api/v2-rise-up-tindahan-ob')
            .then(res => {
              let data = res.data
              this.total_ob = data.total_ob * 1;
              this.evalLoan();
              this.$parent.payloading = false;
            })
            .catch((err) => {
              this.$parent.payloading = false;
            })
        } else {
          this.evalLoan();
        }
      },

      testMaxLoan() {
        let sale = prompt("Enter sample annual sale", '');
        let cat = prompt("Enter sample category(1-4)", '');
        if (sale && cat) {
          this.formLoan.annual_sale = sale * 1;
          this.formLoan.category = cat * 1;
          this.evalLoan();
          this.formLoan.interest_rate_pa = null;
          this.formLoan.service_fee = null;
        }
      },
      changeLoanTerm() {
        this.formLoan.install_fee = null;
        // this.formLoan.grace_period = null;
      },
      evalLoan() {
        this.formLoan.grace_period = 0;
        let sale = this.formLoan.annual_sale * 1;
        let range = null;

        let max = 5000000;
        let str = this.formLoan.start_date;
        let yr = moment().subtract(3, 'years').format();
        switch (this.formLoan.category) {
          case 1:
            range = sale * 0.4;
            this.formLoan.max_loan = Math.min(range, 50000).toFixed();
            break;
          case 2:
            range = sale * 0.4;
            this.formLoan.max_loan = Math.min(range, 300000).toFixed();
            break;
          case 3:
            range = sale * 0.4;
            if (str.includes("/")) {
              str = moment(str, "YYYY-MM-DD").format();
              if (str > yr) {
                max = 1000000;
              }
            }
            if (str.includes("-")) {
              str = moment(str, "YYYY-MM-DD").format();
              if (str > yr) {
                max = 1000000;
              }
            }
            this.formLoan.max_loan = Math.min(range, max).toFixed();
            break;
          case 4:
            // OP #1347
            // range = sale * 0.15;
            range = sale * 0.2;
            if (str.includes("/")) {
              str = moment(str, "YYYY-MM-DD").format();
              if (str > yr) {
                max = 1000000;
              }
            }
            if (str.includes("-")) {
              str = moment(str, "YYYY-MM-DD").format();
              if (str > yr) {
                max = 1000000;
              }
            }
            console.log(yr)
            console.log(str)
            this.formLoan.max_loan = Math.min(range, max).toFixed();
            break;
          default:
        }
      },
      next() {
        this.$parent.submitting = false;
        this.$parent.submitting = true;
        this.formLoan.service_fee = this.service_fee;
        this.formLoan.interest_rate_pa = this.interest_rate;
        this.$v.formLoan.$touch();

        if (this.$v.formLoan.$invalid) {} else {
          this.checkLoanAmount();
        }
      },
      thousands_separators(num) {
        if (num) {
          let num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        }
      },
      submitLoanAmount() {
        if (this.formLoan.req_loan_amt >= 150000) {
          Swal.fire({
            icon: "info",
            html: '<p class="fs-18 mb-0"><b>ISANG PAALALA:</b></p>' +
              '<p class="fs-16 mx-n2">Kung sakaling ang inyong aplikasyon ay ganap na maaprubahan, kakailanganin magsumite ng Post Dated Cheques (PDCs) kasama ng iba pang mga requirements at naayon na kundisyones bago pa man tuluyang matanggap ang inyong CARES loan.</p>' +
              '<hr><p class="fs-18 mb-0"><b>IMPORTANT NOTICE:</b></p>' +
              '<p class="fs-16 mx-n2">(Should your loan application be approved, you shall be required to provide/issue Post Dated Cheques (PDCs) in addition to all other requirements and conditions prior to loan release.)</p>',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$emit("next");
            }
          });
        } else {
          this.$emit("next");
        }
      },
      updateLoanReq() {
        const form = {
          application_id: this.formLoan.application_id,
          max_loan: this.formLoan.max_loan
        };

        this.$parent.payloading = true;
        axios.post('/api/v2-update-loan-req', form)
          .then(res => {
            this.$parent.payloading = false;
            this.submitLoanAmount();
          }).catch(err => {
            this.$parent.payloading = false;
          })
      },
      checkLoanAmount() {
        let loanAmount = this.formLoan.req_loan_amt * 1;
        let maxLoan = this.formLoan.max_loan * 1;
        let amount = this.thousands_separators(maxLoan);

        let minLoan = 10000;

        if (loanAmount < minLoan) {
          Swal.fire({
            icon: "info",
            title: "Reminder",
            html: `Minimum Loan: <b>Php 10,000</b>`,
            allowOutsideClick: false,
          }).then((response) => {
            this.formLoan.req_loan_amt = null;
          });
        } else {
          if (loanAmount > maxLoan) {
            Swal.fire({
              icon: "info",
              title: "Reminder",
              html: `Maximum Loan: <b>Php ${amount}</b>`,
              allowOutsideClick: false,
            }).then((response) => {
              this.formLoan.req_loan_amt = null;
            });
          } else {
            this.updateLoanReq();
          }
        }
      },
      handler($event) {
        if (this.readonly) {
          $event.preventDefault();
        }
      },
    },

  };
</script>



<style scoped>
  label {
    font-weight: 400 !important;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>